import React, { Component } from 'react';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import AgentTabDesc from "../agents/AgentTabDesc";
import AgentDatatable  from "./DepartmentDatatable";
import {addDepartment, editDepartment} from "../../actions/actions";
import Swal from "sweetalert2";
@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Departments extends Component {

    constructor(props) {
        super(props);



        this.state = {
            data: props.chatprop.allAgents
        };

        this.changeDepartmentState = this.changeDepartmentState.bind(this);
        this.editDepartment = this.editDepartment.bind(this);
        this.removeDepartment = this.removeDepartment.bind(this);


    }

    changeDepartmentState(e,id) {
        this.props.dispatch(editDepartment({id:id,checked:e.target.checked}));
    }
    removeDepartment(e,id){
        Swal.fire({
            title: 'Do you want to continue to delete department ?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes!'
        }).then((result) => {
            if (result.isConfirmed) {
                this.props.dispatch(editDepartment({
                    id:id,
                    action:"remove"
                }));
            }
        });
        e.preventDefault();
    }
    editDepartment(e,id) {
        this.props.dispatch({
            type: 'SET_MODAL',
            data: {
                "show": true,
                "page": "editDepartment",
                "data": {
                    id: id
                }
            }
        });
        e.preventDefault();

    }


    render() {
        const { t } = this.props;
        return (
            <div className="agent-list-datatable" style={{"marginTop":"5px","padding":"10px"}}>
                <AgentTabDesc  size="md" modalpage="addDepartment" title="Departments" description="You can list and edit departments." button_title="Add Department" />
                <div style={{marginBottom:"20px"}} />
                <AgentDatatable type="all"  id="departments" editDepartment={this.editDepartment} removeDepartment={this.removeDepartment}  changeDepartmentState={this.changeDepartmentState}  />

            </div>
        );
    }
}

export default withTranslation()(Departments);
